// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProductReviewGraph{margin:20px 0}.ProductReviewGraph-Bar{display:flex;align-items:center}.ProductReviewGraph-Bar span{font-size:14px;line-height:24px;white-space:nowrap}.ProductReviewGraph-Bar span:last-of-type{min-width:32px}.ProductReviewGraph-Bar div{--percentage: 30%;width:100%;height:8px;margin:0 10px;background-color:#E7E2E2;position:relative}.ProductReviewGraph-Bar div::before{content:\" \";position:absolute;background:#000000;width:var(--percentage);height:8px}\n", ""]);
// Exports
module.exports = exports;
